import { createAction } from '~/Helpers/Action.helpers';
import { ALERT_ACTION } from '~/Constants/Actions.constants';

export const updateAlertVisibility = (payload: { key: string; value: boolean }) =>
  createAction({
    name: ALERT_ACTION.UPDATE_ALERT_VISIBILITY,
    type: ALERT_ACTION.UPDATE_ALERT_VISIBILITY,
    payload,
  });
